import GameStepBase from './game_step_base';

// a base class for all Game builder selection game steps
export default class GameUrlBuilderSelectionGameStepBase extends GameStepBase {

}